import { useTheme } from '@mui/material/styles';
import React, { useState, useEffect } from 'react';
import {
  Grid,
  Typography,
  Badge,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Backdrop,
  CircularProgress,
  Link,
  Tooltip,
  Snackbar
} from '@mui/material';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import Avatar from '@mui/material/Avatar';
import Avatar3 from 'src/assets/images/users/avatar-3.png';
import axios from 'src/utils/axios';
import UploadPhoto from './UploadPhoto';
import InfoIcon from '@mui/icons-material/Info';
import { getUser } from 'src/utils/Common';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import AlertComponent from 'src/components/Alert';
import { Alert } from '@mui/material';
import HouseIcon from '@mui/icons-material/House';
import KocAilem from './KocAilem';
import PdfBayi from 'src/assets/pdf/Arçelik_Bayi_Çalışanı_Yetkilisi_Aydınlatma_Metni.pdf';
import PdfServis from 'src/assets/pdf/Arçelik_Yetkili Servis_Çalışanı_Yetkilisi_Aydınlatma_Metni.pdf'

// API bit alanlarını true/false, 1/0 ya da "1"/"0" string olarak dönebiliyor; hepsini normalize eder

const styles = {
  ul: {
    '& .MuiPaginationItem-root': {
      '&.Mui-selected': {
        background: '#FF9800',
        color: 'white',
        borderRadius: '50%',
      },
    },
  },
  backdrop: (theme) => ({
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  }),
};

const Header = ({ EmployeeNr, OrganizationId, Name, Surname, PersonelType, StateId, CellPhone, OrganizationTypeId, KocAilemBaslatilabilir = false, KocAilemKapsamDisi = false }) => {
  const theme = useTheme();
  const [avatarEmployee, setAvatarEmployee] = useState(Avatar3);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(true); // Show backdrop initially
  const [active, setActive] = useState(0);
  const [openProfileImageUploadPopUp, setOpenProfileImageUploadPopUp] = useState(false);
  const [isAvatarEnlarged, setIsAvatarEnlarged] = useState(false);
  const SessionUser = getUser();

  const [Warning, setWarning] = useState(false);
  const [WarningType, setWarningType] = useState('default');
  const [responseMessage, setresponseMessage] = useState("");
  const [kocAilemPopUp, setKocAilemPopUp] = useState(false);
  // Koç Ailem uygunluğu Profile1/index.js'te tek sefer sorgulanıp buraya aktarılıyor;
  // aynı cevabı "Koç Ailem Durumu" sekmesinin görünürlüğü de kullanıyor.
  const kocAilemBaslatilabilir = KocAilemBaslatilabilir;

  const handleAvatarMouseEnter = () => {
    setIsAvatarEnlarged(true);
  };

  const handleAvatarMouseLeave = () => {
    setIsAvatarEnlarged(false);
  };

  useEffect(() => {
    // Fetch the employee information and image independently: one failing (e.g. no photo
    // uploaded yet) must not prevent formData from being set from the other's response.
    setLoading(true);
    axios.get(`GetWorkerInfo/${EmployeeNr}`).then((infoResponse) => {
      const employeeInfo = infoResponse.data[0] || {};
      setFormData(employeeInfo);
      setActive(employeeInfo.Active);
    }).catch(() => {}).finally(() => {
      setLoading(false);
    });

    axios.get(`GetEmployeeImage/${EmployeeNr}`).then((imageResponse) => {
      if (imageResponse.data.length > 0) {
        setAvatarEmployee(imageResponse.data[0].Image);
      }
    }).catch(() => {
      setAvatarEmployee(Avatar3);
    });

  }, [EmployeeNr]);

  const WarningClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setWarning(false);
  };

  const handleUploadPhotoPopUp = () => {
    if (EmployeeNr > 0) {
      setOpenProfileImageUploadPopUp(true);
    } else {
      setOpenProfileImageUploadPopUp(false);
      setresponseMessage("Lütfen önce yeni bir çalışan oluşturup sonradan fotoğraf kaydetmeyi deneyiniz!..");
      setWarning(true);
      setWarningType("error")
    }
  }

  return (
    <Grid container spacing={2} alignItems="center">
      <Backdrop sx={styles.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={Warning}
        autoHideDuration={10000}
        onClose={WarningClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <AlertComponent onClose={WarningClose} variant={WarningType} message={responseMessage}></AlertComponent>
      </Snackbar>
      <Grid>
        <Badge
          overlap="circular"
          // anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          onClick={() => handleUploadPhotoPopUp()}
          badgeContent={
            <AddCircleRoundedIcon color="primary" fontSize="small" />
          }
          style={{ cursor: 'pointer' }}
        >
          <Avatar
            alt={`${Name} ${Surname}`}
            src={avatarEmployee || Avatar3}
            style={{
              width: theme.spacing(11),
              height: theme.spacing(11),
              transformOrigin: 'left top',
              zIndex: isAvatarEnlarged ? 999 : 'auto',
              transform: isAvatarEnlarged ? 'scale(5)' : 'none',
              transition: 'transform 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={handleAvatarMouseEnter}
            onMouseLeave={handleAvatarMouseLeave}
          />

        </Badge>
      </Grid>
      <Grid size="grow">
        <div>
          <Typography align="left" variant="h6">
            {EmployeeNr + '-' + Name + ' ' + Surname}
          </Typography>
          <Typography align="left" variant="subtitle2">
            {PersonelType}
          </Typography>
          <div style={{ display: 'inline-block' }}>
            <Tooltip
              title="Şifre yönetimi için passget.arcelik.com adresini kullabilirsiniz."
              placement="bottom"
            >
              <Link href="https://passget.arcelik.com/" target="_blank" rel="noreferrer" underline="none">
                <Chip
                  label='Şifre Yönetimi'
                  size="small"
                  style={{
                    backgroundColor: '#FF9800',
                    color: 'white',
                    marginTop: '3px',
                    cursor: "pointer"
                  }}
                  icon={<VpnKeyIcon style={{
                    backgroundColor: '#FF9800',
                    color: 'white'
                  }} />}
                />
              </Link>
            </Tooltip>
          </div>
          {/* Bayinin satış bölgesi kapsam dışıysa "KoçAilem İşlemleri" hiç gösterilmiyor.
              Kapsam dışında SP zaten UyelikBaslatilabilirMi = 0 döndürdüğü için koşul
              dolaylı olarak da kapanıyor; niyet kodda görünsün diye açıkça yazıldı. */}
          {!KocAilemKapsamDisi
            && ((formData?.PersonelKocAilemStatus == 1 && OrganizationTypeId == 1) || (OrganizationTypeId == 2 && kocAilemBaslatilabilir)) ?
            <div onClick={() => setKocAilemPopUp(true)} style={{ display: 'inline-block', marginLeft: '10px' }}> {/* Adjust margin as needed */}
              <Tooltip
                title="KoçAilem, Koçluların hayatlarının her alanında kendilerini özel hissetmelerini hedefleyen, Koçlulara özel ayrıcalık platformudur."
                placement="bottom"
              >
                <Chip
                  label='KoçAilem İşlemleri'
                  size="small"
                  style={{
                    backgroundColor: '#33CCFF',
                    color: 'white',
                    marginTop: '3px',
                    cursor: "pointer"
                  }}
                  icon={<HouseIcon style={{
                    backgroundColor: '#33CCFF',
                    color: 'white'
                  }}
                  />}
                />
              </Tooltip>
            </div>
            : null}
          <div style={{ display: 'inline-block', marginLeft: '10px' }}>
            <Tooltip
              title="Aydınlatma metnine ulaşmak için tıklayınız."
              placement="bottom"
            >
              <Link href={OrganizationTypeId === 2 ? PdfBayi : PdfServis} target="_blank" rel="noreferrer" underline="none">
                <Chip
                  label='Aydınlatma Metni'
                  size="small"
                  color="secondary"
                  style={{
                    marginTop: '3px',
                    cursor: "pointer"
                  }}
                  icon={<InfoIcon />}
                />
              </Link>
            </Tooltip>
          </div>
        </div>
      </Grid>
      <Grid style={{ textAlign: 'left' }} size={6}>
        {/* {Kvkk === 1 ? (
          <VerifiedUserIcon style={{ color: 'green' }} />
        ) : (
          <VerifiedUserIcon style={{ color: 'red' }} title="Bu kullanıcı Kvkk izni vermemiştir!..." />
        )} */}
      </Grid>
      <Grid>
        <Chip
          label={StateId ? 'Aktif' : 'Pasif'}
          size="small"
          style={{
            backgroundColor: StateId ? '#00C853' : '#D84315',
            color: 'white'
          }}
          sx={{
            bgcolor: theme.palette.mode === 'dark' ? theme.palette.dark.dark : 'error.light',
            color: 'error.dark'
          }}
        />
      </Grid>
      <Dialog
        open={openProfileImageUploadPopUp}
        onClose={() => setOpenProfileImageUploadPopUp(false)}
      >
        <DialogTitle>Profil Resmi Yükle</DialogTitle>
        <Grid container spacing={2}>
          <Grid
            size={{
              xs: 12,
              sm: 12,
              md: 12
            }}>
            {/*  */}
          </Grid>
        </Grid>
        <DialogContent>
          <Alert variant="outlined" severity="error" sx={{ borderColor: theme.palette.warning.dark }}>
            <Typography variant='h5' style={{ color: 'red' }}>Fotoğraflarda beyaz arka plan kullanılmalıdır. Erkek çalışanın, yetkili servis tişörtü ile, kadın çalışanın beyaz gömlek ile çekilmiş fotoğrafı yüklenmelidir. Fotoğraf çekilirken; göğüs üstü hizalanarak 45 derecelik açı ile durulması, görünen bir takı olmaması, düzgün ve şekli dağınık olmayan saç/sakal konusunda hassasiyet gösterilmesi gerekmektedir.
            </Typography>
          </Alert>
          <UploadPhoto
            EmployeeImage={avatarEmployee}
            EmployeeNr={EmployeeNr}
            ServiceShopId={formData?.ServiceShopId}
            setOpenProfileImageUploadPopUp={setOpenProfileImageUploadPopUp}
            setAvatarEmployee={setAvatarEmployee}
            setWarning={setWarning}
            setWarningType={setWarningType}
            setresponseMessage={setresponseMessage}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenProfileImageUploadPopUp(false)} autoFocus>
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={kocAilemPopUp}
        onClose={() => setKocAilemPopUp(false)}
      >
        <DialogTitle>KoçAilem Onay</DialogTitle>
        <DialogContent>
          <KocAilem
            EmployeeNr={EmployeeNr}
            CellPhone={formData?.CellPhone}
            setKocAilemPopUp={setKocAilemPopUp}
            OrganizationTypeId={OrganizationTypeId}
            setWarning={setWarning}
            setWarningType={setWarningType}
            setresponseMessage={setresponseMessage}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setKocAilemPopUp(false)} autoFocus>
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default Header;
